import React from 'react';

import './Form.scss';
import FontAwesomeIcon from '../Icon';
import Row from '../Row';
import Col from '../Col';

const Form = ({
  actions,
  component,
  footer,
  headline,
  onClose,
  onSubmit,
  strapline,
  onExit,
}) => (
  <form
    className="form"
    onSubmit={e => {
      e.preventDefault();
      if (onSubmit) {
        onSubmit();
      }
    }}
  >
    <div className="form__header">
      {onClose && (
        <button
          type="button"
          className="form__dismiss"
          onClick={onClose}
        >
          <FontAwesomeIcon
            weight="light"
            glyph="arrow-left"
          />
        </button>
      )}
      <div className="form__actions">
        {actions}
        {onExit && (
          <button
            type="button"
            className="form__dismiss"
            onClick={onExit}
          >
            <FontAwesomeIcon
              weight="light"
              glyph="times"
            />
          </button>
        )}
      </div>
    </div>
    <div className="form__body formpopupScroll">
      <div className="form__headline">
        {headline}
      </div>
      {strapline && (
        <Row mdCenter>
          <Col
            xs={12}
            md={4}
          >
            <div className="form__strapline">
              {strapline}
            </div>
          </Col>
        </Row>

      )}
      <div className="wrapper">
        {component}
      </div>
    </div>
    {footer && (
      <div className="form__footer">
        <Row mdCenter>
          <Col
            xs={12}
          >
            <div className='footerBtniOs'>
            {footer}
          </div>
            
          </Col>
        </Row>
      </div>
    )}
  </form>
);

export default Form;
